import useLocalStorage from '@rehooks/local-storage'
import { ConnectedUser } from '@ucc/admin-global-state'

import { config } from 'config'
import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from 'utils/constants'

const useLocale = (): string => {
  const [iAmInfos] = useLocalStorage<ConnectedUser>(config.I_AM_TOKEN_KEY)
  return (iAmInfos && SUPPORTED_LOCALES.find((locale) => locale === iAmInfos.locale)) || DEFAULT_LOCALE
}
export default useLocale
